import { Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Heading, Paragraph } from 'design-system/components/Text';

const HeaderContainer = styled('header')`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: ${Spacing[3]} ${Spacing[5]};
  background-color: ${({ theme }) => theme.color.background.primary};
  border-bottom: 1px solid ${({ theme }) => theme.color.border.primary};
  box-sizing: border-box;
  min-height: 56px; /* Standardize height for most PageHeaders */
`;

const TitleContainer = styled('div')`
  display: flex;
  flex: 1;
  align-items: center;
  h1 {
    margin: 0;
  }
  p {
    margin: 0 0 0 ${Spacing[2]};
  }
`;

const LeftContainer = styled('div')`
  display: flex;
  align-items: center;
`;

const RightContainer = styled('div')`
  display: flex;
  gap: ${Spacing[2]};
  margin-left: ${Spacing[3]};
`;

interface PageHeaderProps {
  title: ReactNode;
  level?: 'product' | 'detail';
  subtitle?: ReactNode;
  prepend?: ReactNode;
  append?: ReactNode;
  children?: ReactNode;
}

const PageHeader = ({
  title,
  subtitle,
  level = 'product',
  prepend,
  append,
  children,
  ...props
}: PageHeaderProps) => (
  <HeaderContainer {...props}>
    <LeftContainer>
      {prepend && <div>{prepend}</div>}
      <TitleContainer>
        {level === 'product' && (
          <Heading as='h1' size='sm'>
            {title}
          </Heading>
        )}
        {level === 'detail' && (
          <Paragraph as='h1' size='lg' color='primary'>
            {title}
          </Paragraph>
        )}
        {subtitle && <Paragraph size='md'>{subtitle}</Paragraph>}
      </TitleContainer>
      {append && <div>{append}</div>}
    </LeftContainer>
    {children && <RightContainer>{children}</RightContainer>}
  </HeaderContainer>
);

export default PageHeader;
